export default "__VITE_ASSET__nbRfS$TG__"